module.exports = __webpack_public_path__ + "quotezone-ui/img/rim-black.b6261ad4.png";